<template>
  <vue-crop  @crop-upload-success="uploadSuccess" @crop-success="cropSuccess" @crop-upload-fail="cropUploadFail"
             v-model="show"
             :width="width"
             :height="height"
             :field="fileName"
             :noRotate="false"
             img-format="png"></vue-crop>
</template>

<script>
  import VueCrop from 'vue-image-crop-upload/upload-2.vue';
  import {myphotoUpload} from '@/api/attachment'
  export default{
    props:{
      value:{
        type:Boolean
      },
      width:{
        type:Number,
        default:200
      },
      height:{
        type:Number,
        default:200
      },
      /*上传图片的file控件name*/
      fileName: {
        type: String
      },
    },
    data(){
      return {
        show: false,
      }
    },
    mounted(){
      this.show=this.value;
    },
    components: {
      VueCrop
    },
    methods: {
      uploadSuccess(res, field) {
        //console.log(res);
        //this.$emit('uploadSuccess',res);
      },
      cropSuccess(imgDataUrl, field) {
        myphotoUpload( this.convertBase64UrlToBlob(imgDataUrl)).then(response=>{
          this.$emit('uploadSuccess',response.data.url+'?ra='+Math.random());
        })
      },
      convertBase64UrlToBlob(urlData) {

        var bytes = window.atob(urlData.split(',')[1]);        //去掉url的头，并转换为byte

        //处理异常,将ascii码小于0的转换为大于0
        var ab = new ArrayBuffer(bytes.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < bytes.length; i++) {
          ia[i] = bytes.charCodeAt(i);
        }

        return new Blob([ab], {type: 'image/png'});
      },
      cropUploadFail(status, field) {
        console.log('-------- upload fail --------');
        console.log(status);
        console.log('field: ' + field);
      }
    },
    watch:{
      value(newv){
        this.show=newv;
      },
      show(newv){
        if(!this.show)
          this.$emit('input',false);
      }
    }
  }
</script>

<style>
  .vue-image-crop-upload .vicp-rotate i{
    background-color:#4a7 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/CropUpload.vue